import React from "react";

import {
  Dialog,
  DialogContent,
  SimpleList,
  SimpleListItem,
} from "@tiny/components";
import { useSegmentListView } from "../SegmentList.context";

interface SegmentMoreDialogProps {
  open: boolean;
  onClose: () => void;
}

function SegmentMoreDialog(props: SegmentMoreDialogProps) {
  const { open, onClose } = props;

  const { openFilters, openSort } = useSegmentListView();

  return (
    <Dialog open={open} onClose={onClose} disableEscapeKeyDown fullWidth>
      <DialogContent paddingTop={1} paddingBottom={3}>
        <SimpleList>
          <SimpleListItem
            size="large"
            onClick={() => {
              openFilters();
              onClose();
            }}
          >
            Filter
          </SimpleListItem>
          <SimpleListItem
            size="large"
            onClick={() => {
              openSort();
              onClose();
            }}
          >
            Sort
          </SimpleListItem>
        </SimpleList>
      </DialogContent>
    </Dialog>
  );
}

export default SegmentMoreDialog;
